export default "__VITE_ASSET__BiD8Hf93__"